import { getAssetUrl } from "@src/utils/assets/getAssetUrl";
import { cn } from "@src/lib/utils";

interface LogoProps extends React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> {}

export const Logo = ({ className, ...restProps }: LogoProps) => {
  return (
    <img
      {...restProps}
      src={getAssetUrl("/images/logo.svg")}
      alt="Stitch Logo"
      className={cn("size-8 object-contain", className)}
    />
  );
};
